import { Stores } from '@bee-hole/api';
import { Context, useStoreFactory } from '@vue-storefront/core';

export const useStore = useStoreFactory<Stores>({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async load(context: Context, params) {
    const res = await context.$xbuy.api.shopView();
    if (res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data.list;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  change(context: Context, params) {
    return Promise.resolve(null);
  }
});
